import Layout from "../components/Layout/Layout";
import { Error } from "../components/UI";

const ErrorPage = () => {
  return (
    <Layout>
      <Error />
    </Layout>
  );
};

export default ErrorPage;
